/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-radiation.reducer';

export const TreatmentRadiationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRadiationEntity = useAppSelector(state => state.treatmentRadiation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRadiationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRadiation.detail.title">TreatmentRadiation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.id}</dd>
          <dt>
            <span id="administered">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.administered">Administered</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.administered ? 'true' : 'false'}</dd>
          <dt>
            <span id="immobilized">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.immobilized">Immobilized</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.immobilized ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.plannedRadiationType">Planned Radiation Type</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.plannedRadiationType ? treatmentRadiationEntity.plannedRadiationType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.administeredRadiationType">Administered Radiation Type</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.administeredRadiationType ? treatmentRadiationEntity.administeredRadiationType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.beamDetails">Beam Details</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.beamDetails ? treatmentRadiationEntity.beamDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.doseDetails">Dose Details</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.doseDetails ? treatmentRadiationEntity.doseDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.techniquDetails">Techniqu Details</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.techniquDetails ? treatmentRadiationEntity.techniquDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiation.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentRadiationEntity.cycle ? treatmentRadiationEntity.cycle.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-radiation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-radiation/${treatmentRadiationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRadiationDetail;
